import axios from 'axios';
import { set } from 'lodash-es';
import { setToken, getToken, clearToken } from './system';
import webConfig from './httpUrlConfig';

const xToken = 'X-Token';

axios.defaults.baseURL = '';
axios.defaults.timeout = 1000 * 60 * 60;

axios.interceptors.request.use(
  async (config) => {
    const token = getToken();

    if (token && config.headers) {
      set(config.headers, xToken, token);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    if (response?.headers?.newToken) {
      setToken(response.headers.newToken);
    }
    if (Number(response.status) === 200) {
      if (
        response?.data?.status !== '200' &&
        (response?.data?.status === '401' || response?.data?.status === '403')
      ) {
        if (window.dts.identify === 'ft') {
          window.location.reload();
        }
        clearToken();
        return Promise.reject(response);
      }

      if (response?.data?.status === '412') {
        if (window.location.href.includes('/ht')) {
          window.location.href = (webConfig.online + '/ht/#/NoPermission') as string;
        }
        return Promise.reject(response);
      }

      if (response?.data?.status === '500') {
        return Promise.reject(response);
      }

      return Promise.resolve(response.data);
    }
    clearToken();
    window.location.reload();
    return Promise.reject(response);
  },
  (error) => {
    if (axios.isCancel(error)) {
      return new Promise(() => {});
    }
    return Promise.reject(error.response);
  },
);

export default axios;
